import React from 'react';
import './AboutPillars.scss';
import Reveal from '../Reveal/Reveal';
// New pillar photography
import professionimg from '../../images/BackgroundImages/professionevent.JPEG';
import serviceimg from '../../images/BackgroundImages/serviceevent.JPEG';
import kinshipimg from '../../images/BackgroundImages/kinshipnew.JPEG';

// The three pillars, presented as alternating image+text spreads on paper.
// Copy below is unchanged from the chapter's existing pillar descriptions.
const pillars = [
  {
    id: 'profession',
    image: professionimg,
    alt: 'Professional Development',
    heading: 'Profession',
    subheading: 'Excellence in Engineering',
    body:
      'We provide opportunities for technical development, leadership experience, and career advancement through events, mentorship, and alumni engagement.',
  },
  {
    id: 'brotherhood',
    image: kinshipimg,
    alt: 'Brotherhood',
    heading: 'Brotherhood',
    subheading: 'Strong Bonds, Stronger Brotherhood',
    body:
      'Through shared experiences and traditions, we build lifelong friendships and a supportive community both on and off campus.',
  },
  {
    id: 'service',
    image: serviceimg,
    alt: 'Service Work',
    heading: 'Service',
    subheading: 'Impact Through Action',
    body:
      'We organize and participate in service initiatives that support both our campus and local community. Service is at the core of what we do.',
  },
];

// Component that displays the three core pillars of Theta Tau:
// Profession, Brotherhood, and Service, as alternating image+text spreads.
function AboutPillars() {
  return (
    <section className="AboutPillarsContainer" aria-labelledby="pillars-heading">
      <div className="PillarsHeader">
        <h2 className="PillarsTitle" id="pillars-heading">Our Pillars</h2>
        <p className="PillarsPar">
          Profession, Brotherhood and Service form the foundation of our collective journey as an organization.
        </p>
      </div>

      <div className="PillarsSpread">
        {pillars.map((pillar, index) => (
          <article
            className={`pillar-leaf ${index % 2 === 1 ? 'pillar-leaf--reverse' : ''}`}
            key={pillar.id}
          >
            <Reveal as="div" variant="plate" index={index} className="pillar-leaf-frame">
              <img src={pillar.image} alt={pillar.alt} loading="lazy" />
            </Reveal>
            <Reveal as="div" variant="rise" index={index + 1} className="pillar-leaf-copy">
              <h3>{pillar.heading}</h3>
              <h4>{pillar.subheading}</h4>
              <p>{pillar.body}</p>
            </Reveal>
          </article>
        ))}
      </div>
    </section>
  );
}

export default AboutPillars;
